export function initHeroSliders($) {
  $('.hero--slider-bgi').not('.slick-initialized').slick({
    arrows: false,
    asNavFor: '.hero--slider-sync',
    cssEase: 'ease-in-out',
    speed: 1000,
    infinite: true,
  });
  $('.hero--slider-content').not('.slick-initialized').slick({
    // arrows: false,
    fade: true,
    speed: 1000,
    infinite: true,
    asNavFor: '.hero--slider-sync',
    prevArrow: $('.hero--arrows .prev'),
    nextArrow: $('.hero--arrows .next'),
  });
  
}
